export default "__VITE_ASSET__DdsWmW3z__"